import { Button } from "@remo-co/ui-core/src/components/Button";
import { ContactSupport } from "@remo-co/ui-core/src/icons/ContactSupport";
import { useI18n } from "i18n";
import { ICompany } from "modules/company/types";
import { IEvent } from "modules/event/types";
import { ContactHostDialog } from "modules/eventLanding/components/ContactHostDialog";
import { useContext, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { Events, TRACKING_CONTEXT } from "modules/tracking";
import { selectUser } from "modules/auth/redux/selectors";
import { selectCurrentEventCompany } from "modules/event/selectors";
import classNames from "classnames";
import { useStyles } from "./styles";
import { ContactHostOrigin } from "../../constants";

interface Props {
  origin: ContactHostOrigin;
  positionedAbsolute?: boolean;
  event: IEvent | null;
}

export const ContactHost = ({ origin, event, positionedAbsolute }: Props) => {
  const { track } = useContext(TRACKING_CONTEXT);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const user = useSelector(selectUser);
  const eventCompany = useSelector(selectCurrentEventCompany);
  const { t } = useI18n(["common"]);
  const styles = useStyles();

  const companyName = useMemo(
    () =>
      !eventCompany || typeof eventCompany === "string"
        ? undefined
        : (eventCompany as ICompany).name,
    [eventCompany],
  );

  const handleButtonClick = () => {
    setIsDialogOpen(true);
    track(Events.CONTACT_HOST_CLICKED, {
      eventId: event?.id,
      url: origin,
      userId: user?.id,
    });
  };

  if (!event || !event.contactChannels || event.contactChannels.length === 0) {
    return null;
  }

  return (
    <>
      <Button
        onClick={handleButtonClick}
        variant="secondary"
        color="dark"
        size="md"
        className={classNames(styles.actionButtons, {
          [styles.absolute]: positionedAbsolute,
          [styles.relative]: !positionedAbsolute,
        })}
      >
        <ContactSupport className={styles.actionButtonIcons} />{" "}
        {t("common:contact.host")}
      </Button>
      {isDialogOpen && (
        <ContactHostDialog
          origin={origin}
          companyName={companyName}
          event={event}
          close={() => setIsDialogOpen(false)}
        />
      )}
    </>
  );
};
